/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Gads_Not_ConfiguredInputs */

const cs_integrations_gads_not_configured = /** @type {(inputs: Integrations_Gads_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Ads není na serveru nastavené. Požádejte správce o konfiguraci.`)
};

const en_integrations_gads_not_configured = /** @type {(inputs: Integrations_Gads_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Ads is not configured on this server. Ask an administrator to set it up.`)
};

/**
* | output |
* | --- |
* | "Google Ads is not configured on this server. Ask an administrator to set it up." |
*
* @param {Integrations_Gads_Not_ConfiguredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_gads_not_configured = /** @type {((inputs?: Integrations_Gads_Not_ConfiguredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Gads_Not_ConfiguredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_gads_not_configured(inputs)
	return cs_integrations_gads_not_configured(inputs)
});